import { StateCreator } from "zustand";

export type TrackingState = {
  tracking: {
    siteCode: string;
    siteId: string;
    siteName: string;
    size: string;
    bookingId?: string;
    currency?: string;
    storageValue?: string;
    firstMonthValue?: string;
    ordinaryMonthValue?: string;
    clientType?: string;
    insurance?: string;
    paymentMethod?: string;
    hashedEmail?: string;
    appVersion?: string;
    sizeGroup?: string;
    useSigning?: boolean;
    signingCompleted?: boolean;
    customerId?: string;
    paymentOrderId?: string;
    country?: string;
    payeeReference?: string;
    isPerson?: boolean;
    currentStorageSizeId?: number;
    currentStorageSizeLink?: string;
    currentStorageName?: string;
    currentStorageSize?: string;
    currentStoragePrice?: number;
    currentStorageSpecialPrice?: number;
    currentStorageDescription?: string;
    currentStorageMovingBoxesCount?: string;
    currentStorageShortName?: string;
    currentStorageFirstMonthDiscount?: boolean;
    filteredStorageSizeId?: number;
    filteredStorageGroupName?: string;
    filteredStorageGroupNameShort?: string;
    filteredSizeCodeId?: string;
    filteredSizeInM2?: string;
    filteredSizeVolume?: string;
    filteredSizePrice?: number;
    filteredSizeOrdPrice?: number;
    filteredSizeDiscount?: number;
    filteredSizeSiteId?: string;
    filteredExactSizeCodeId?: string;
    selectedFloor?: string;
    selectedFeature?: string;
    selectedUnitNumber?: string;
    selectedSizeId?: number;
    selectedPrice?: string;
    selectedDate?: string;
  };
};

export type TrackingActions = {
  setTrackingValue: (key: keyof TrackingState["tracking"], value: any) => void;
  resetTracking: () => void;
};

const initialState: TrackingState = {
  tracking: {
    siteCode: "",
    siteId: "",
    siteName: "",
    size: "",
    bookingId: undefined,
    currency: undefined,
    storageValue: undefined,
    firstMonthValue: undefined,
    ordinaryMonthValue: undefined,
    clientType: undefined,
    insurance: undefined,
    paymentMethod: undefined,
    hashedEmail: undefined,
    appVersion: undefined,
    useSigning: undefined,
    signingCompleted: undefined,
    customerId: undefined,
    paymentOrderId: undefined,
    country: undefined,
    payeeReference: undefined,
    isPerson: undefined,
    currentStorageSizeLink: undefined,
    currentStorageName: undefined,
    currentStorageSize: undefined,
    currentStoragePrice: undefined,
    currentStorageSpecialPrice: undefined,
    currentStorageDescription: undefined,
    currentStorageMovingBoxesCount: undefined,
    currentStorageShortName: undefined,
    currentStorageFirstMonthDiscount: undefined,
    filteredStorageSizeId: undefined,
    filteredStorageGroupName: undefined,
    filteredStorageGroupNameShort: undefined,
    filteredSizeCodeId: undefined,
    filteredSizeInM2: undefined,
    filteredSizeVolume: undefined,
    filteredSizePrice: undefined,
    filteredSizeOrdPrice: undefined,
    filteredSizeDiscount: undefined,
    filteredSizeSiteId: undefined,
    selectedFloor: undefined,
    selectedFeature: undefined,
    selectedUnitNumber: undefined,
    selectedSizeId: undefined,
    selectedPrice: undefined,
    selectedDate: undefined,
  },
};
export const createTrackingSlice: StateCreator<TrackingState & TrackingActions> = (
  set
) => ({
  tracking: {
    siteCode: "",
    siteId: "",
    siteName: "",
    size: "",
    bookingId: undefined,
    currency: undefined,
    storageValue: undefined,
    firstMonthValue: undefined,
    ordinaryMonthValue: undefined,
    clientType: undefined,
    insurance: undefined,
    paymentMethod: undefined,
    hashedEmail: undefined,
    appVersion: undefined,
    useSigning: undefined,
    signingCompleted: undefined,
    customerId: undefined,
    paymentOrderId: undefined,
    country: undefined,
    payeeReference: undefined,
    isPerson: undefined,
    currentStorageSizeLink: undefined,
    currentStorageName: undefined,
    currentStorageSize: undefined,
    currentStoragePrice: undefined,
    currentStorageSpecialPrice: undefined,
    currentStorageDescription: undefined,
    currentStorageMovingBoxesCount: undefined,
    currentStorageShortName: undefined,
    currentStorageFirstMonthDiscount: undefined,
    filteredStorageSizeId: undefined,
    filteredStorageGroupName: undefined,
    filteredStorageGroupNameShort: undefined,
    filteredSizeCodeId: undefined,
    filteredSizeInM2: undefined,
    filteredSizeVolume: undefined,
    filteredSizePrice: undefined,
    filteredSizeOrdPrice: undefined,
    filteredSizeDiscount: undefined,
    filteredSizeSiteId: undefined,
    selectedFloor: undefined,
    selectedFeature: undefined,
    selectedUnitNumber: undefined,
    selectedSizeId: undefined,
    selectedPrice: undefined,
    selectedDate: undefined,
  },
  setTrackingValue: (key, value) =>
    set((state) => ({
      tracking: {
        ...state.tracking,
        [key]: value,
      },
    })),
  resetTracking: () => set(() => initialState),
});
